import React from 'react';
import './IconList.scss';

interface IconListItem {
  message: React.ReactNode;
  Icon: React.ComponentType;
}

interface IconListProps {
  title: string;
  data: IconListItem[];
}

const IconList: React.FC<IconListProps> = ({ title, data }) => {
  return (
    <div className="icon-item-content">
      <span className="b-typography-sans-serif--headline--100 b-font-weight-bold">
        {title}
      </span>
      {data.map((item, index) => (
        <div key={index} className="icon-item b-padding-block--micro--normal">
          <div className="icon-item-icon">
            <item.Icon data-testid="checkmark-completed-icon" />
          </div>
          <span className="b-typography-sans-serif--body--200 b-font-weight-light b-padding-inline--micro--normal message">
            {item.message}
          </span>
        </div>
      ))}
    </div>
  );
};

export default IconList;
